<template>
  <div class="goodsDetailsPage">
    <!-- header start -->
    <van-nav-bar
      title="产品详情"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <section class="swiper-area">
        <van-swipe :autoplay="5000" @change="onChange">
          <van-swipe-item
            v-for="(banner, index) in bannerPicArray"
            :key="index"
          >
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="banner.imageUrl"
              @click="preview(index)"
            />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <i v-text="currentIndex + 1"></i> /
              <i>{{ bannerPicArray.length }}</i>
            </div>
          </template>
        </van-swipe>
      </section>
      <section class="pro-head">
        <div class="price">
          ￥<span class="money">{{ productApiModel.Price }}</span>
        </div>
        <h2 class="title">{{ productApiModel.ProductName }}</h2>
      </section>
      <section class="pro-body">
        <div class="title">产品详情</div>
        <div class="tbody" v-html="productApiModel.Content"></div>
      </section>
      <section v-if="!notShow" class="details__bottom">
        <van-button
          block
          color="orange"
          size="large"
          :to="{ path: '/BookingForm' }"
          >立即预约</van-button
        >
      </section>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      pid: "",
      puid: "",
      images: [],
      currentIndex: 0,
      productApiModel: {},
      notShow: false,
      bannerPicArray: [
        // {imageUrl:'https://resources.ninghao.org/images/candy-shop.jpg'},
        // {imageUrl:'https://resources.ninghao.org/images/childhood-in-a-picture.jpg'},
        // {imageUrl:'https://resources.ninghao.org/images/contained.jpg'},
      ],
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2 !important");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onChange(index) {
      this.currentIndex = index;
    },
    preview(index) {
      ImagePreview({
        // images: [
        //   'https://resources.ninghao.org/images/candy-shop.jpg',
        //   'https://resources.ninghao.org/images/childhood-in-a-picture.jpg',
        //   'https://resources.ninghao.org/images/contained.jpg',
        // ],
        images: this.images,
        startPosition: index,
      });
    },
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetProductProductDetail",
          productId: that.puid,
        })
        .then(
          (res) => {
            that.productApiModel = res.ProductApiModel;
            if (res.ProductApiModel) {
              // 储存
              that.$store.commit("setProductApiModel", res.ProductApiModel);
            }
            if (
              res.ProductApiModel.I_ProductPhotoList &&
              res.ProductApiModel.I_ProductPhotoList.length > 0
            ) {
              res.ProductApiModel.I_ProductPhotoList.map((e) => {
                that.bannerPicArray.push({ imageUrl: e.ImagePath });
                that.images.push(e.ImagePath);
              });
            } else {
              that.bannerPicArray.push({
                imageUrl: res.ProductApiModel.CoverPhoto,
              });
              that.images.push(res.ProductApiModel.CoverPhoto);
            }
          },
          (err) => {}
        );
    },
  },
  created() {
    this.pid = this.$route.query.pid + "";
    this.puid = this.$route.query.puid;
    this.notShow = this.$route.query.notShow;
    this.init();
  },
};
</script>

<style scoped>
.swiper-area {
  height: 260px;
}
.van-swipe {
  width: 100%;
  height: 100%;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.goodsDetailsPage {
  padding-bottom: 50px;
}
.details__bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.details__bottom .van-button {
  height: 50px;
  line-height: 50px;
}
.pro-head {
  background-color: #fff;
  padding: 10px;
}
.pro-head .price {
  font-size: 14px;
  color: crimson;
  margin-bottom: 2px;
}
.pro-head .price .money {
  font-size: 21px;
}
.pro-head .title {
  font-size: 15px;
  font-weight: normal;
  line-height: 1.5;
}
.pro-body {
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #fff;
}
.pro-body .title {
  font-size: 14px;
  color: #666;
  padding: 12px 10px;
}
</style>
